import React from "react"; 

// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";

import axios from 'axios'
import style from './styles.module.css'
import Button from '@material-ui/core/Button'
import ConfUser from './confUser/ConfUser'
import IconButton from '@material-ui/core/IconButton'
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import InputRoundedIcon from '@material-ui/icons/InputRounded';
import Snackbar from '../utils/snackbar/Snackbar'
import {withRouter} from 'react-router-dom' 
import CircularProgress from '@material-ui/core/CircularProgress'
import TopBar from "../utils/Topbar/TopBar.js";
import {connect} from 'react-redux'
import ConfirmAlert from "../utils/ConfirmAlert/ConfirmAlert.js";

const Users = (props) => { 
  const [data,setData] = React.useState(false)
  const [filteredData,setFilteredData] = React.useState(false)
  const [searchValue,setSearchValue] = React.useState("")
  const [selectValue,setSelectValue] = React.useState("ALL")
  const [alert,setAlert] = React.useState(false);
  const [addModal,setAddModal] = React.useState(false);
  const [editModal,setEditModal] = React.useState(false);
  const [activeUser,setActiveUser] = React.useState(false) 

  React.useEffect(() => {
    fetchOrder()
  },[]);


  React.useEffect(() => {
    if(data) {
      let arr = [];
      arr = data.filter(val => {
        if( val.userName.toLowerCase().includes(searchValue.toLowerCase()) || 
            val.email.toLowerCase().includes(searchValue.toLowerCase()) || 
            val.userAddress.toLowerCase().includes(searchValue.toLowerCase())
          ) {
          return val;
        }
      })
      arr = arr.filter(val => {
        if(val.userType == selectValue || selectValue == "ALL") {
          return val;
        }
      })
      setFilteredData(arr);
    }
  },[searchValue,selectValue])

  const fetchOrder = () => {
    setData(false);
    axios({
      method: "post",
      url: "/getAllUserApi", 
      data: {
        userId: props.user._id
      }
    }).then(res => {
      setData(res.data.data)  
      setFilteredData(res.data.data)
    }).catch(err => {
      console.log(err)
    });
  }


  const handleDelete = (value) => {
    axios({
      method: "post",
      url: "/deleteUserApi",
      data: {
        userId: value._id,
      }
    }).then(res => {
      setAlert("Deleted Successfully")
      fetchOrder();
    }).catch(err => {
      setAlert("Something went wrong");
    })
  }

  const isLoading = !filteredData;
  const showData = !isLoading;
  const details = [];
 
  let userTypes = ["ALL"]
  data && data.forEach(val => { 
    userTypes.push(val.userType);
  }); 
  userTypes = [...new Set(userTypes)]

  
  !isLoading && filteredData.forEach((val,index) => {
    details.push(
      [
        index + 1,
        val.userName,
        val.contactNum,
        val.userType,
        val.email,
        val.userAddress, 
        <React.Fragment>  
          <IconButton onClick={() => {
            setActiveUser(val)
            setEditModal(true)
          }}>
            <EditRoundedIcon />
          </IconButton>
          <ConfirmAlert msg={`Are you sure you want delete ?`} onClickEvent={() => handleDelete(val)}> 
            <IconButton>
              <DeleteRoundedIcon />
            </IconButton>
          </ConfirmAlert>
        </React.Fragment>
      ]
    )
  });


  return (
    <GridContainer>
      
      {addModal && <ConfUser
        type="ADD" 
        open={addModal} 
        onClose={() => setAddModal(false)} 
        onDone={() => {
          setAddModal(false)
          fetchOrder()
        }}
        setAlert={(msg) => setAlert(msg)}
      />}
      
      {activeUser && <ConfUser 
        type="EDIT"
        userData={activeUser} 
        open={editModal} 
        onClose={() => setEditModal(false)} 
        onDone={() => {
          setEditModal(false)
          setActiveUser(false)
          fetchOrder()
        }} 
        setAlert={(msg) => setAlert(msg)}
      />} 
 
      <Snackbar open={alert} handleClose={() => setAlert(false)}/>
 
      <TopBar 
        searchValue={searchValue} 
        onSearchChange={(value) => setSearchValue(value)} 

        select={true}
        selectValue={selectValue}
        handleSelectChange={(value) => setSelectValue(value)}
        lable="Status"
        options={userTypes}
        values={userTypes}
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>All Users</h4> 
              <Button color="secondary" variant="contained" onClick={() => setAddModal(true)}>Add User</Button>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading &&
              <div className={style.loader}>
                <CircularProgress />
              </div>
            }
            
            {showData && 
              <Table
                tableHeaderColor="primary"
                tableHead={["Sl No", "user Name", "Contact", "User Type", "Email", "Address", "Action"]}
                tableData={details}
              />}
          </CardBody>
        </Card>
      </GridItem> 
    </GridContainer>
  );
}

const mapStateToProps = state => ({
  user: state.appReducer.user
})
export default withRouter(connect(mapStateToProps)(Users));